<template>
    <div class="bread-crumbs">
        <div class="list">
            <div v-for="(item, key) in items"
                 :key="key"
                 @click="change(item, key)"
                 :class="['item align-center', {'disabled': item.disabled}]">
                <div v-if="key" class="divider">
                    <icon name="angle" width="12px" height="12px" fill="var(--lighten-7-color)" />
                </div>
                <span class="text">{{item.text}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "breadCrumbs",
        props: {
            // divider: {
            //     type: String,
            //     default: '–'
            // },
            items: {
                type: Array,
                required: true
            }
        },
        methods: {
            change(item, key) {
                if (item.disabled) return;

                this.$emit('change', {target: item, key})
            }
        }
    }
</script>

<style scoped>

    .list {
        display: flex;
        align-items: center;
    }
    .item {
        font-size: 15px;
        color: var(--primary-color);
        font-weight: 500;
        cursor: pointer;
    }
    .item.disabled {
        cursor: default;
    }
    .item.disabled .text {
        position: relative;
    }
    .item.disabled .text::before {
        content: "";
        position: absolute;
        bottom: -6px;
        left: 0;
        right: 0;
        height: 2px;
        background-color: var(--primary-color);
    }

    .item .divider {
        display: inline-block;
        margin: 0 16px;
        width: 12px;
        height: 8px;
        transform: rotate(-90deg) translateY(-5px);
    }

</style>